import React from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'

function Layout() {
  const location = useLocation();
 

  const shouldShowHeader = !/^\/mvp\/configuration/.test(location.pathname);


  return (
    <div className='flex flex-row bg-neutral-100 h-screen w-screen overflow-hidden'>
        <Sidebar />
        <div className='flex-1 flex flex-col'>
            {shouldShowHeader && <Header />}
            <div className='overflow-y-auto flex-1'>{<Outlet />}</div>
        </div>
    </div>
  )
}

export default Layout
